import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./Aboutus.module.css";
import { useSelector } from "react-redux";
export default function AboutInfo() {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className={styles.aboutInfoContainer}>
      <Container fluid>
        <Row>
          <Col md={4}>
            <div className={styles.aboutDes}>

              <div className={styles.visionTitle}>{currentLocal.general.vision}</div>
              <div className={styles.visionDesc}>{currentLocal.general.visionDesc}</div>
            </div>
          </Col>
          {/* <Col md={4}>
            <div className={styles.aboutDes}>

              <div className={styles.visionTitle}>{currentLocal.general.goal}</div>
              <div className={styles.visionDesc}>{currentLocal.general.goalDesc}</div>
            </div>

          </Col> */}
          <Col md={4}>
            <div className={styles.aboutDes}>
              <div className={styles.visionTitle}>{currentLocal.general.message}</div>
              <div className={styles.visionDesc}>{currentLocal.general.messageDesc}</div>
            </div>
          </Col>
          <Col md={4}>
            <div className={styles.aboutDes}>
              <div className={styles.visionTitle}>{currentLocal.general.value}</div>
              <div className={styles.visionDesc}>{currentLocal.general.valueDesc}</div>
            </div>

          </Col>
          <Col md={4}>

          </Col>
          {/* <Col md={4}>
            <div className={styles.aboutDes}>
              <div className={styles.visionTitle}>{currentLocal.general.ourfeatures}</div>
              <ul className={styles.visionDesc}>
                <li><p>{currentLocal.general.featureone}</p></li>
                <li><p>{currentLocal.general.featureTwo}</p></li>
                <li><p>{currentLocal.general.featureThree}</p></li>
              </ul>
            </div>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}
